import React, { useRef, useEffect } from 'react';

import Footer from '../components/Footer';
import {Link} from 'react-router-dom'

const Services = ({ setPage }) => {
   const spotlightRef = useRef(null);

  useEffect(() => {
    const spotlight = spotlightRef.current;
    if (!spotlight || !spotlight.parentElement) return;

    const parent = spotlight.parentElement;
    const handleMouseMove = (e) => {
      const rect = parent.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      spotlight.style.setProperty('--mouse-x', `${x}px`);
      spotlight.style.setProperty('--mouse-y', `${y}px`);
      spotlight.classList.add('active');
    };
    const handleMouseLeave = () => {
      spotlight.classList.remove('active');
    };
    parent.addEventListener('mousemove', handleMouseMove);
    parent.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      parent.removeEventListener('mousemove', handleMouseMove);
      parent.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

   return (
     <div>
       {/* <Navbar setPage={setPage} /> */}
       {/* Cover Image Section */}
     <section className="services-cover-section">
        <img
          src="/images/about.jpg" // replace with your actual image path
          alt="Our Services Cover"
          className="services-cover-image"
        />
        <div className="services-cover-overlay">
          <div className='service-cover-text'>
          <h1 className="services-cover-title">Our Services</h1>
          <p className="services-cover-subtitle">Empowering Maritime Excellence</p>
          </div>
        </div>
     </section>
        <section className="mcd-services-section">
          <div className="mcd-container-services">
             {/* <h1 className="mcd-section-title-services">Our Services</h1> */}
              <div className="mcd-services-grid">
                <div className="mcd-service-card">
                <Link to="/services/ship-management">
                   <h2>Ship Management (Technical and Crew)</h2>
                   <p>Comprehensive ship management with technical oversight and skilled crew deployment, ensuring safe and efficient operations.</p>
                </Link>
                </div>

                {/* NEW SHIP DESIGN & NAVAL ARCHITECTURE CARD */}
                <div className="mcd-service-card highlight-service-card">
                    <Link to="/services/ship-design-naval-architecture">
                  <h2>Ship Design, Naval Architecture Services & Boat Building</h2>
                  <p style={{ color: "#f5f5f5ff" }}>We provide naval architecture, marine design, and boat-building solutions tailored to your operational requirements. From concept and engineering design to construction, modification, and delivery, our team supports the development of steel and aluminum vessels, workboats, barges, crew boats, supply boats, and tugboats with a focus on quality, safety, and performance.</p>
                  </Link>
                </div>

                <div className="mcd-service-card">
                     <Link to="/services/tug-barge-operations">
                   <h2>Tug & Barge Operations</h2>
                   <p>Expert handling of tug and barge logistics for industrial transport, optimizing safety and reliability.</p>
                   </Link>
                </div>
                {/* <div className="mcd-service-card">
                     <Link to="/services/crew">
                   <h2>Crew Manning & Supply</h2>
                   <p>Providing certified crew and supply solutions to meet the demands of global maritime operations.</p>
                   </Link>
                </div> */}
                <div className="mcd-service-card">
                     <Link to="/services/marine">
                   <h2>Marine Technical Services</h2>
                   <p>Specialized technical support for vessel maintenance and performance enhancement.</p>
                   </Link>
                </div>
                <div className="mcd-service-card">
                     <Link to="/services/drydock">
                   <h2>Ship Drydock Services</h2>
                   <ul>
                     <li>Drydock planning and supervision</li>
                     <li>Hull inspection and steel repairs</li>
                     <li>Painting, blasting, and machinery overhaul</li>
                     <li>Coordination with the Class and regulatory authorities</li>
                   </ul>
                   </Link>
                </div>
                <div className="mcd-service-card">
                     <Link to="/services/voyage">
                   <h2>Voyage Repairs & Afloat Maintenance</h2>
                   <p>On-the-go repair and maintenance services to minimize downtime during voyages.</p>
                   </Link>
                </div>
                <div className="mcd-service-card">
                     <Link to="/services/bunker">
                   <h2>Bunker & Fresh Water Supply</h2>
                   <p>Reliable supply of bunker fuel and fresh water to support uninterrupted operations.</p>
                   </Link>
                </div>
                <div className="mcd-service-card">
                     <Link to="/services/spare">
                   <h2>Spare Parts Procurement & Delivery</h2>
                   <p>Efficient procurement and timely delivery of spare parts to keep vessels operational.</p>
                   </Link>
                </div>
                {/* MARITIME SECURITY CARD */}
                <div className="mcd-service-card">
                     <Link to="/services/maritime-security">
                   <h2>Maritime Security</h2>
                   <p>Protecting vessels and crew with expert risk assessment, counter-piracy measures, and security personnel deployment.</p>
                   </Link>
                </div>
              </div>

              {/* FEATURED NAVAL ARCHITECTURE SHOWCASE SECTION WITH ANIMATION */}
              <div className="naval-architecture-showcase-section inline-showcase">
                <div className="naval-blueprint-card">
                  <div className="blueprint-grid-overlay"></div>
                  
                  <div className="naval-card-header">
                    <span className="naval-badge-subtitle">FEATURED ENGINEERING CAPABILITY</span>
                    <h2>SHIP DESIGN, NAVAL ARCHITECTURE & BOAT BUILDING</h2>
                    <p className="naval-card-desc">
                      We provide naval architecture, marine design, and boat-building solutions tailored to your operational requirements. From concept and engineering design to construction, modification, and delivery, our team supports the development of steel and aluminum vessels, workboats, barges, crew boats, supply boats, and tugboats with a focus on quality, safety, and performance.
                    </p>
                  </div>

                  <div className="naval-process-badges">
                    <div className="naval-process-badge">
                      <div className="badge-icon">🚢</div>
                      <span>CONCEPT DESIGN</span>
                    </div>
                    <div className="naval-process-badge">
                      <div className="badge-icon">🧊</div>
                      <span>3D MODELING</span>
                    </div>
                    <div className="naval-process-badge">
                      <div className="badge-icon">📐</div>
                      <span>NAVAL ARCHITECTURE</span>
                    </div>
                    <div className="naval-process-badge">
                      <div className="badge-icon">⚙️</div>
                      <span>DETAIL DESIGN</span>
                    </div>
                  </div>

                  <div className="naval-showcase-grid">
                    <div className="naval-highlights-column">
                      <div className="naval-highlight-badge">
                        <div className="highlight-icon">📐</div>
                        <div className="highlight-text">
                          <h4>ACCURATE DESIGN & CALCULATIONS</h4>
                          <p>Precise hydrostatics, stability analysis, and CFD hull optimization.</p>
                        </div>
                      </div>

                      <div className="naval-highlight-badge">
                        <div className="highlight-icon">🛡️</div>
                        <div className="highlight-text">
                          <h4>CLASS & REGULATION COMPLIANT</h4>
                          <p>Full approval and compliance with IACS Classification Societies & IMO standards.</p>
                        </div>
                      </div>

                      <div className="naval-highlight-badge">
                        <div className="highlight-icon">📦</div>
                        <div className="highlight-text">
                          <h4>EFFICIENT, SAFE & COST OPTIMIZED</h4>
                          <p>Tailored steel and aluminum vessel construction for peak performance.</p>
                        </div>
                      </div>
                    </div>

                    <div className="naval-blueprint-visual-wrapper">
                      <div className="blueprint-image-frame">
                        <img
                          src="/images/ship-design-blueprint.webp"
                          alt="Ship Design & Naval Architecture Blueprint Schematics"
                          className="blueprint-img-animated"
                        />
                        <div className="blueprint-scanline"></div>
                      </div>
                    </div>
                  </div>

                  <div className="naval-vessels-supported">
                    <h3>Vessels We Design & Build</h3>
                    <div className="vessel-chips">
                      <span className="chip">Steel & Aluminum Vessels</span>
                      <span className="chip">Workboats</span>
                      <span className="chip">Barges</span>
                      <span className="chip">Crew Boats</span>
                      <span className="chip">Supply Boats</span>
                      <span className="chip">Tugboats</span>
                    </div>
                    <div style={{ marginTop: '1.5rem' }}>
                      <Link to="/services/ship-design-naval-architecture" className="cta-button">
                        Explore Full Naval Architecture Services →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div ref={spotlightRef} className="mcd-spotlight-effect"></div>
        </section>
        <Footer/>
     </div>
   );
};

export default Services;